// extracted by mini-css-extract-plugin
module.exports = {"attribute-header":"attributes-tree_attribute-header__3c8Kn","attribute-title":"attributes-tree_attribute-title__2ZVWa"};